import { irstore } from '@/fetch/interface';
import axios from '@/axios';

export const defaultVersion = 'v1';

export const loaderFactories = {
	// 模块翻译列表
	trans_modules:
		ctx =>
		(params = {}) => {
			return axios.get(irstore.tranModuleIds(ctx.storeId), {
				...params
			});
		},

	// Banner模块
	banner:
		ctx =>
		(params = {}) => {
			return axios.get(irstore.getBannerList(ctx.storeId), {
				languageType: ctx.languageType,
				...params
			});
		},

	// 自定义模块
	custom:
		ctx =>
		(params = {}) => {
			return axios.get(irstore.getCustomModuleContent(ctx.storeId), {
				languageType: ctx.languageType,
				...params // 分页参数 pageStart, pageNum 和 moduleId 由组件传入
			});
		},

	news:
		ctx =>
		(params = {}) => {
			return axios.get(irstore.getNewsList(ctx.storeId), {
				...params,
				languageType: ctx.languageType
			});
		},
	news_detail:
		ctx =>
		(params = {}) => {
			return axios.get(irstore.getNewsDetails(params.storeId || ctx.storeId, params.newsId), {
				languageType: ctx.languageType,
				...params
			});
		},
	quarterly_performance:
		ctx =>
		(params = {}) => {
			return axios.get(irstore.getPerformance(ctx.storeId), {
				...params,
				languageType: ctx.languageType
			});
		},
	quote:
		ctx =>
		(params = {}) => {
			let market = ctx.market,
				code = ctx.code;
			if (params.market) market = params.market;
			if (params.code) code = params.code;
			// realType 1=实时数据，支持每分钟查询
			const requestParams = {
				languageType: ctx.languageType
			};
			if (params.realType !== undefined) {
				requestParams.realType = params.realType;
			}
			return axios.get(
				irstore.getStockQuote(market, code),
				{
					...requestParams
				},
				{
					headers: {
						showLoading: false
					}
				}
			);
		},
	quote_sse:
		ctx =>
		(params = {}) => {
			// 上交所数据, 接入后才支持查询，支持每秒查询
			return axios.post(
				irstore.getSseStockQuotation,
				{
					fullCode: ctx.code,
					types: ['line', 'snap']
				},
				{
					headers: {
						showLoading: false
					}
				}
			);
		},

	margin_funds:
		ctx =>
		(params = {}) => {
			return axios.get(irstore.getStockMarginFunds(ctx.fullCode), {
				...params,
				languageType: ctx.languageType
			});
		},

	// 公告模块
	announcement:
		ctx =>
		(params = {}) => {
			return axios.get(irstore.getAnnouncements(params.storeId || ctx.storeId), {
				languageType: ctx.languageType,
				isPublish: true,
				...params // 分页参数 pageStart, pageNum 和其他动态参数由组件传入
			});
		},
	announcement_tabs:
		ctx =>
		(params = {}) => {
			return axios.get(irstore.getModulesTabList(ctx.storeId, ctx.pageId, 'announcement'), {
				...params
			});
		},

	appointment_surveyInfo:
		ctx =>
		(params = {}) => {
			return axios.get(irstore.getSurveyInfo(ctx.storeId, params.type));
		},
	appointment_applySurveyRecord:
		ctx =>
		(params = {}) => {
			return axios.post(irstore.applySurveyRecord(params.id), params.params);
		},
	leave_word_config:
		ctx =>
		(params = {}) => {
			return axios.get(irstore.getLeaveWordConfig(ctx.storeId), {
				languageType: ctx.languageType
			});
		},
	leave_word_create:
		ctx =>
		(params = {}) => {
			return axios.post(irstore.createLeaveWord(ctx.storeId), {
				...params,
				languageType: ctx.languageType
			});
		},
	message_subscription_messageMailCode:
		ctx =>
		(params = {}) => {
			return axios.post(
				irstore.getMessageMailCode(ctx.storeId),
				{
					...params,
					languageType: ctx.languageType
				},
				{
					retry: false,
					hideError: true
				}
			);
		},
	message_subscription_create:
		ctx =>
		(params = {}) => {
			return axios.post(
				irstore.createMessageContact(ctx.storeId),
				{
					...params
				},
				{
					retry: false,
					hideError: true
				}
			);
		},

	// 企业简介模块
	company_profile:
		ctx =>
		(params = {}) => {
			return axios.get(irstore.getCompanyInfo(ctx.storeId), {
				...params
			});
		},
	message_event:
		ctx =>
		(params = {}) => {
			return axios.get(irstore.getMessageEvent(ctx.storeId), {
				languageType: ctx.languageType
			});
		},
	message_contact_config:
		ctx =>
		(params = {}) => {
			return axios.get(irstore.getMessageContactConfig(ctx.storeId), {
				...params,
				languageType: ctx.languageType
			});
		},
	question:
		ctx =>
		(params = {}) => {
			return axios.post(irstore.postAdvisoryList, {
				...params,
				fullCode: ctx.fullCode,
				storeId: ctx.storeId,
				languageType: ctx.languageType
			});
		},

	// 投关活动
	investment_activity:
		ctx =>
		(params = {}) => {
			return axios.post(irstore.postAllActivityList(ctx.storeId), {
				languageType: ctx.languageType,
				...params
			});
		},
	roadshow:
		ctx =>
		(params = {}) => {
			return axios.get(irstore.getRoadshowList(ctx.storeId), {
				languageType: ctx.languageType,
				isPublish: true,
				...params
			});
		},
	offline:
		ctx =>
		(params = {}) => {
			return axios.get(irstore.getActivityList(ctx.storeId), {
				languageType: ctx.languageType,
				isPublish: true,
				...params
			});
		},
	research:
		ctx =>
		(params = {}) => {
			return axios.post(irstore.getSummaryList(ctx.storeId), {
				languageType: ctx.languageType,
				isPublish: true,
				...params
			});
		},

	// 研报模块
	report_list:
		ctx =>
		(params = {}) => {
			return axios.post(irstore.postReportList, {
				fullCode: ctx.fullCode,
				languageType: ctx.languageType,
				...params
			});
		},
	report_detail:
		ctx =>
		(params = {}) => {
			return axios.post(irstore.postReportDetail, {
				languageType: ctx.languageType,
				...params
			});
		},
	report_tabs:
		ctx =>
		(params = {}) => {
			return axios.get(irstore.getModulesTabList(ctx.storeId, ctx.pageId, 'report'), {
				...params
			});
		},
	// 股东模块
	shareholder_count:
		ctx =>
		(params = {}) => {
			return axios.get(irstore.getShareholderList(ctx.market, ctx.code), {
				...params
			});
		},
	// 业绩报告模块
	performance_report:
		ctx =>
		(params = {}) => {
			return axios.get(irstore.getPerformance(ctx.storeId), {
				languageType: ctx.languageType,
				isAll: true,
				...params
			});
		},
	institutional_holding:
		ctx =>
		(params = {}) => {
			return axios.get(irstore.getPreInstitutionHoldings(ctx.market, ctx.code), {
				...params
			});
		},
	institutional_holding_date:
		ctx =>
		(params = {}) => {
			return axios.get(irstore.getInstitutionHoldingsDate(ctx.market, ctx.code), {
				...params
			});
		},
	top_ten_shareholder:
		ctx =>
		(params = {}) => {
			return axios.get(irstore.getTopTenHoldings(ctx.market, ctx.code), {
				...params
			});
		},
	top_ten_shareholder_date:
		ctx =>
		(params = {}) => {
			return axios.get(irstore.getTopTenHoldingsDate(ctx.market, ctx.code), {
				...params
			});
		},

	// ESG 模块
	esg:
		ctx =>
		(params = {}) => {
			return axios.get(irstore.getESGData(ctx.fullCode), {
				languageType: ctx.languageType,
				...params
			});
		},
	esg_report:
		ctx =>
		(params = {}) => {
			return axios.get(irstore.getCustomModuleContent(ctx.storeId), {
				languageType: ctx.languageType,
				...params
			});
		},

	customs_calendar:
		ctx =>
		(params = {}) => {
			return axios.post(irstore.apiPostScheduleList(ctx.storeId), {
				languageType: ctx.languageType,
				...params
			});
		},
	customs_calendar_latest:
		ctx =>
		(params = {}) => {
			return axios.post(irstore.getScheduleLatestThree(ctx.storeId), {
				languageType: ctx.languageType,
				pageNum: 0,
				pageSize: 3,
				...params
			});
		},

	// 美股公告模块
	us_announcement:
		ctx =>
		(params = {}) => {
			return axios.get(irstore.getUsAnnouncements(ctx.storeId), {
				title: '', // 固定参数
				...params // 分页参数 pageStart, pageNum 和动态参数 typeList 由组件传入
			});
		},
	us_announcement_type:
		ctx =>
		(params = {}) => {
			return axios.get(irstore.getUsAnnouncementType(ctx.storeId), {
				...params
			});
		},

	// 分红计划模块
	dividend_plan_summary:
		ctx =>
		(params = {}) => {
			return axios.get(irstore.getDividendPlanSummary(ctx.fullCode), {
				...params
			});
		},
	dividend_plan:
		ctx =>
		(params = {}) => {
			return axios.get(irstore.getStockDividendPlan(ctx.fullCode), {
				...params
			});
		},

	// 财务数据模块
	main_index:
		ctx =>
		(params = {}) => {
			return axios.get(irstore.getMain(ctx.market, ctx.code), {
				languageType: ctx.languageType,
				...params
			});
		},
	balance_sheet:
		ctx =>
		(params = {}) => {
			return axios.get(irstore.getLiabilities(ctx.market, ctx.code), {
				languageType: ctx.languageType,
				...params
			});
		},
	profit_statement:
		ctx =>
		(params = {}) => {
			return axios.get(irstore.getProfit(ctx.market, ctx.code), {
				languageType: ctx.languageType,
				...params
			});
		},
	cash_flow_statement:
		ctx =>
		(params = {}) => {
			return axios.get(irstore.getCash(ctx.market, ctx.code), {
				languageType: ctx.languageType,
				...params
			});
		},

	// 沪深港通资金流向模块
	north_south_funds:
		ctx =>
		(params = {}) => {
			return axios.get(irstore.getStockMorthSouthFunds(ctx.fullCode), {
				...params // 分页参数 pageStart, pageNum 由组件传入
			});
		},

	// 基金持股模块
	fund_holding:
		ctx =>
		(params = {}) => {
			return axios.get(irstore.getStockFundHolding(ctx.fullCode), {
				...params
			});
		},
	fund_holding_page:
		ctx =>
		(params = {}) => {
			return axios.get(irstore.getStockFundHoldingPage(ctx.fullCode), {
				...params // 分页参数 pagestart, pagenum 和其他参数 period, year 由组件传入
			});
		},

	// 公司治理模块
	corporate_governance:
		ctx =>
		(params = {}) => {
			return axios.get(irstore.getCorporateData(ctx.storeId), {
				isPublish: true,
				languageType: ctx.languageType,
				...params
			});
		},
	//股东大会
	shareholder_meeting:
		ctx =>
		(params = {}) => {
			return axios.get(irstore.getShareholderMeeting(ctx.fullCode));
		}
};
